import React, { useMemo } from 'react'
import BotaoCTA from '../../BotaoCTA'
import { CardTexto, CardTitulo } from '../../Cards/CardImagemVazada/styles'
import ReactMarkdown from 'react-markdown'
import { CardContainer, CardBotao } from './styles'

const CardSimplesBotao = ({ card }) => {
    const { titulo, descricao, botao, alinhamento } = card

    const hasTitle = useMemo(() => {
        if (!titulo) return null
        return (
            <CardTitulo alinhamento={alinhamento}>
                {' '}
                <ReactMarkdown>{titulo}</ReactMarkdown>{' '}
            </CardTitulo>
        )
    }, [alinhamento, titulo])

    const hasDescription = useMemo(() => {
        if (!descricao) return null
        return (
            <CardTexto alinhamento={alinhamento}>
                {' '}
                <ReactMarkdown>{descricao}</ReactMarkdown>{' '}
            </CardTexto>
        )
    }, [alinhamento, descricao])

    const hasButton = useMemo(() => {
        if (!botao) return null
        return (
            <CardBotao alinhamento={alinhamento}>
                <BotaoCTA botao={botao} />
            </CardBotao>
        )
    }, [alinhamento, botao])

    return (
        <CardContainer>
            {hasTitle}
            {hasDescription}
            {hasButton}
        </CardContainer>
    )
}

export default CardSimplesBotao
